<template>
  <v-container>
    <v-textarea
      v-model="customer.tbObservacao"
      label="Observações"
      solo-filled
      auto-grow
      readonly
    />
  </v-container>
</template>

<script>
  export default {
    name: 'Observations',
    props: {
      customer: {
        type: Object,
        required: true,
      },
    },
  }
</script>
